import React, { useEffect, useState, useRef } from "react";
/* Components */
import Button from "../button/button";
/* Styles */
import "./chat.css";
/* Assets */
import shaia from "../../assets/Shaia.png";
import userImg from "../../assets/Img_profile.svg";
import { useMutation, useQueryClient } from "react-query";
import { fetchChatGPT } from "../../services/chat.service";
import useQuery from '../../hooks/useQuery';

export const typesAllowed = ["actividad-clase-conversacion","proyecto"];

const Chat = ({ handleHiddenEditor = null }) => {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const queryClient = useQueryClient();
  const query = useQuery();
  const type = query.get("type") || "coaching";
  const regex = /<plan>(.*?)<\/plan>/;

  const mutation = useMutation(fetchChatGPT, {
    onSuccess: (res) => {
      queryClient.invalidateQueries("gpt-response");
      queryClient.setQueryData(["gpt-response"], res?.messages);
      // sendEvent(`SHAIA_USE_CASE_${type.toUpperCase()}`)
      let currentMessages = res?.messages;
      if (
        typesAllowed.includes(type) &&
        currentMessages &&
        currentMessages.length &&
        handleHiddenEditor
      ) {
        const hasPlan = currentMessages.some(
          (e) => e.role === "assistant" && e.content.match(regex)
        );
        if (hasPlan) {
          currentMessages = res?.messages.map((e) => {
            let content = e.content;
            if (e.role === "assistant" && e.content.match(regex)) {
              const beforeTagPlanText = e.content.indexOf("<plan>");
              const afterTagPlanText =
                e.content.indexOf("</plan>") + "</plan>".length;
              const beforePlanTag = e.content.substring(0, beforeTagPlanText);
              const afterPlanTag = e.content.substring(afterTagPlanText);
              content = beforePlanTag + afterPlanTag;
            }
            return { ...e, content };
          });
          handleHiddenEditor(false);
        }
      }
      setMessages(currentMessages);
      setLoading(false);
      setNewMessage("");
    },
    onError: () => {
      setLoading(false);
    },
  });

  const chatContainerRef = useRef(null);

  useEffect(() => {
    scrollToBottom(); 
  }, []);

  function scrollToBottom() {
    const lastMessage = chatContainerRef.current.lastElementChild;
    if (lastMessage) {
      lastMessage.scrollIntoView();
    }
  }

  const sendMessage = () => {
    if (newMessage.trim() !== "") {
      const payload = { role: "user", content: newMessage };
      setMessages((prevMessages) => [...prevMessages, payload]);
      setLoading(true);
      setNewMessage("");
      mutation.mutate({ messages: [...messages, payload], type: type }).then(() => {
        scrollToBottom(); // Llama a scrollToBottom después de agregar el nuevo mensaje
      });;
    }
  };

  useEffect(() => {
    // Llama a scrollToBottom cada vez que se actualiza el estado de messages
    scrollToBottom();
  }, [messages]);

  useEffect(() => {
    const payload = { role: "user", content: "Hola" };
    mutation.mutate({ messages: [...messages, payload], type: type });
    // eslint-disable-next-line
  }, []);

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Evita el comportamiento predeterminado de "Enter" en un textarea (añadir una nueva línea)
      if (newMessage.trim() !== "") {
        const payload = { role: "user", content: newMessage };
        setMessages((prevMessages) => [...prevMessages, payload]);
        setLoading(true);
        setNewMessage("");
        mutation.mutate({ messages: [...messages, payload], type: type });
      }
    }
  };

  return (
    <div className="main-chat">
      <div className="chat_wrapper">
        <div ref={chatContainerRef} className="chat_wrapper-scroll">
          {messages
            ?.filter((e) => e.role === "user" || e.role === "assistant")
            .filter((e) => e.content !== "Hola")
            .map((message, i) => (
              <div
                key={i}
                className={`chat_conversation-thread-${
                  message.role === "user" ? "user" : "ai"
                }`}
              >
                <div class="bubble-wrapper">
                  <div
                    className={`chat_bubble-${
                      message.role === "user" ? "user" : "ai"
                    }`}
                  >
                    <div class="group">
                      <span class="bubble-name">
                        {message.role === "user" && "Tú"}
                        {message.role === "assistant" && "Shaia"}
                      </span>
                    </div>
                    <p className="bubble-message">
                      {message.role === "user" && message.content}
                      {message.role === "assistant" && message.content}
                    </p>
                  </div>
                </div>
                <div
                  className={`chat_avatar-${
                    message.role === "user" ? "user" : "ai"
                  }`}
                >
                  {message.role === "user" && <img src={userImg} alt="Tú" />}
                  {message.role === "assistant" && (
                    <img src={shaia} alt="Sha.ia" />
                  )}
                </div>
              </div>
            ))}
        </div>
      </div>
      <div className="chat_input">
        <textarea
          className="input-box"
          placeholder="Type your message..."
          rows="4"
          cols="50"
          value={newMessage}
          disabled={loading}
          onChange={(e) => setNewMessage(e.target.value)}
          onKeyPress={handleKeyPress}
        />
        <Button
          label={loading ? "Enviando ..." : "Enviar"}
          variant="primary"
          disabled={loading}
          onClick={sendMessage}
        />
      </div>
    </div>
  );
};

export default Chat;
